import React, { useEffect, useLayoutEffect, useRef } from "react";
import { Button, ButtonGroup } from "react-bootstrap";

export interface ContextMenuOption {
  text: string;
  data?: any;
}

export const ContextMenuSeparatorText = "---";

interface ContextMenuProps {
  onClick: (options: ContextMenuOption) => void;
  onClose: () => void;
  options: ContextMenuOption[];
  positionX: number;
  positionY: number;
}

function ModelInfoContextMenu({
  onClick,
  onClose,
  options,
  positionX,
  positionY,
}: ContextMenuProps) {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        !event.target ||
        !(event.target as HTMLElement).closest(".context-menu")
      ) {
        onClose();
      }
    };

    const handleResize = () => onClose();
    const handleScroll = () => onClose();

    document.addEventListener("click", handleClickOutside, true);
    window.addEventListener("resize", handleResize, true);
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      window.removeEventListener("resize", handleResize, true);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [onClose]);

  const buttonGroupRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    var elem = buttonGroupRef?.current;
    if (elem) {
      if (
        positionY + elem.clientHeight >
        document.documentElement.clientHeight
      ) {
        elem.style.top = "";
        elem.style.bottom = "0";
      } else {
        elem.style.top = positionY.toString() + "px";
        elem.style.bottom = "";
      }

      if (positionX + elem.clientWidth > document.documentElement.clientWidth) {
        elem.style.left = "";
        elem.style.right = "0";
      } else {
        elem.style.left = positionX.toString() + "px";
        elem.style.right = "";
      }
    }
  }, [positionX, positionY]);

  return (
    <ButtonGroup
      ref={buttonGroupRef}
      vertical
      style={{
        position: "fixed",
        zIndex: 1000,
      }}
      className="context-menu"
    >
      {options.map((option, key) =>
        option.text !== ContextMenuSeparatorText ? (
          <Button key={key} variant="secondary" onClick={() => onClick(option)}>
            {option.text}
          </Button>
        ) : (
          <div
            key={key}
            style={{ padding: "1px", backgroundColor: "white", width: "100%" }}
          />
        ),
      )}
    </ButtonGroup>
  );
}

export default ModelInfoContextMenu;
